import { sendDependant } from './sendDependant'
import store from 'utils/store/withMiddleware'
import { SFResponse } from '../types'

function handleResponseLead(leadResponse: SFResponse): SFResponse | null {
  if (!leadResponse) {
    return null
  }
  const { id } = leadResponse

  if (!id) {
    return null
  }

  const { hcStorage } = store.getState()
  sessionStorage.setItem(`pivotSFLeadId-${hcStorage.contact.email_address}`, id)

  if (hcStorage.members.length > 1 && id) {
    sendDependant(hcStorage.members, id)
  }
  return leadResponse
}

export { handleResponseLead }
